<div class="w-100">
  <div class="sales-summary-header">
    <h2 class="sales-summary-header__label">Selecione a informação:</h2>
    <div class="sales-summary-tabs" role="tablist" aria-label="Resumo de vendas">
      <button
        type="button"
        class="sales-summary-tabs__button"
        [class.sales-summary-tabs__button--active]="activeTab === 'batch'"
        (click)="setActiveTab('batch')">
        Vendas por lote
      </button>
      <button
        type="button"
        class="sales-summary-tabs__button"
        [class.sales-summary-tabs__button--active]="activeTab === 'seller'"
        (click)="setActiveTab('seller')">
        Vendas por vendedor
      </button>
    </div>
  </div>

  @if (activeTab === "batch") {
    <p-table
      [value]="data"
      [tableStyle]="{ 'min-width': '40rem' }"
      [paginator]="true"
      [rowsPerPageOptions]="[5, 10, 20]"
      [rows]="5">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="batch_index">LOTE <p-sortIcon field="batch_index" class="white" /></th>
          <th pSortableColumn="title">CATEGORIA <p-sortIcon field="title" /></th>
          <th pSortableColumn="sold_quantity">QTD VENDIDA <p-sortIcon field="sold_quantity" /></th>
          <th pSortableColumn="unit_price">VALOR UNITÁRIO <p-sortIcon field="unit_price" /></th>
          <th pSortableColumn="total">TOTAL <p-sortIcon field="total" /></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-batch>
        <tr>
          <td>Lote {{ batch.batch_index }}</td>
          @if (batch.title === "Guests") {
            <td>Convites</td>
          } @else {
            <td>{{ batch.title }}</td>
          }
          <td>{{ batch.sold_quantity }}</td>
          <td>{{ batch.unit_price | currency: "BRL" }}</td>
          <td>{{ batch.total | currency: "BRL" }}</td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p-table
      [value]="sellerSummaryPage?.data ?? []"
      [tableStyle]="{ 'min-width': '40rem' }"
      [paginator]="true"
      [lazy]="true"
      [rows]="5"
      [rowsPerPageOptions]="[5, 10, 20]"
      [totalRecords]="sellerSummaryPage?.meta?.total_count ?? 0"
      (onPage)="handleSellerPageChange($event)">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="seller_name">VENDEDOR <p-sortIcon field="seller_name" /></th>
          <th pSortableColumn="orders_count">VENDAS REALIZADAS <p-sortIcon field="orders_count" /></th>
          <th pSortableColumn="tickets_count">INGRESSOS VENDIDOS <p-sortIcon field="tickets_count" /></th>
          <th pSortableColumn="total_revenue">TOTAL <p-sortIcon field="total_revenue" /></th>
          <th>DETALHES</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-seller>
        <tr>
          <td>
            <div class="seller-cell">
              <span>{{ seller.seller_name }}</span>
              <small>{{ seller.seller_email }}</small>
            </div>
          </td>
          <td>{{ seller.orders_count }}</td>
          <td>{{ seller.tickets_count }}</td>
          <td>{{ seller.total_revenue | currency: "BRL" }}</td>
          <td>
            <button type="button" class="seller-details-button" (click)="openSellerDetails(seller)">
              <i class="pi pi-eye" aria-hidden="true"></i>
              Detalhes
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">Nenhuma venda por vendedor encontrada.</td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
